// @flow
export const RENAME_CAMPAIGN_FORM = {
  OPEN: 'RENAME_CAMPAIGN_FORM.OPEN',
  CLOSE: 'RENAME_CAMPAIGN_FORM.CLOSE',
  UPDATE: 'RENAME_CAMPAIGN_FORM.UPDATE'
}

type State = {|
  +isOpened: boolean,
  +currentName: string,
  +campaignName: string,
  +campaignId: string,
  +patching: boolean,
  +errors: boolean,
  +errorMessages: Object
|}

type Action = {
  type: string,
  state: $Shape<State>
}

export type { State }

const initialState = {
  isOpened: false,
  currentName: '',
  campaignName: '',
  campaignId: '',
  patching: false,
  errors: false,
  errorMessages: {}
}

export function open(state: Object = {}): Action {
  return { type: RENAME_CAMPAIGN_FORM.OPEN, state }
}

export function close() {
  return { type: RENAME_CAMPAIGN_FORM.CLOSE }
}

export function update(state: Object = {}): Action {
  return { type: RENAME_CAMPAIGN_FORM.UPDATE, state }
}

export default function renameCampaignForm(state: State = initialState, action: Action) {
  switch (action.type) {
    case RENAME_CAMPAIGN_FORM.OPEN:
      return { ...initialState, ...action.state, isOpened: true }
    case RENAME_CAMPAIGN_FORM.CLOSE:
      return { ...initialState, isOpened: false }
    case RENAME_CAMPAIGN_FORM.UPDATE:
      return { ...state, ...action.state }
    default:
      return state
  }
}
